import script from "./SiteHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./SiteHeader.vue?vue&type=script&lang=ts&setup=true"

import "./SiteHeader.vue?vue&type=style&index=0&id=5739377c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5739377c"]])

export default __exports__